import {
  ApiResponse,
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "@/data/apiClient";

export interface Notification {
  id: string;
  title: string;
  text: string;
  fromDate: string;
  toDate: string;
  userTitle: string;
  status: string;
}

function reformatDate(d: string): string {
  return /\d{2}\D\d{2}\D\d{4}/.exec(d)
    ? `${d.slice(6, 10)}-${d.slice(3, 5)}-${d.slice(0, 2)}`
    : d;
}

export const getActiveNotifications = async (
  clientKey: string,
  app?: string
): Promise<ApiResponse<Notification[]>> => {
  if (!clientKey) [];
  return getRequest("activeNotifications", {
    clientKey,
    app: app || undefined,
  });
};

export const getNotifications = async (
  app: string | undefined
): Promise<ApiResponse<Notification[]>> =>
  getRequest("notifications", { app: app || undefined });

export const addNotification = async (
  app: string,
  n: Notification
): Promise<ApiResponse<string>> =>
  postRequest("notification", {
    ...n,
    fromDate: reformatDate(n.fromDate),
    toDate: reformatDate(n.toDate),
    app: app || undefined,
  });

export const updateNotification = async (
  app: string | undefined,
  n: Notification
): Promise<ApiResponse<string>> =>
  putRequest("notification", {
    ...n,
    fromDate: reformatDate(n.fromDate),
    toDate: reformatDate(n.toDate),
    app: app || undefined,
  });

export const reOrderNotifications = async (
  terms: Notification[],
  app: string
): Promise<ApiResponse<string>> =>
  postRequest("notifications", {
    ids: terms.map((t) => t.id),
    app: app || undefined,
  });

export const deleteNotification = async (
  id: string
): Promise<ApiResponse<string>> => deleteRequest("notification", { id });
